// frontend/src/components/auth/AuthWrapper.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import PasswordChangeDialog from './PasswordChangeDialog';
import toast from 'react-hot-toast';

const AuthWrapper = ({ children }) => {
  const { user, updateUserLocally } = useAuth();
  const [showPasswordChange, setShowPasswordChange] = useState(false);

  // Check if user needs to change password
  useEffect(() => {
    if (user?.requirePasswordChange === true) {
      setShowPasswordChange(true);
    }
  }, [user]);

  const handlePasswordChangeSuccess = () => {
    setShowPasswordChange(false);
    // Update user state to reflect password change requirement is fulfilled
    if (user) {
      updateUserLocally({ ...user, requirePasswordChange: false });
    }
  };

  return (
    <>
      {children}
      <PasswordChangeDialog 
        open={showPasswordChange}
        onSuccess={handlePasswordChangeSuccess}
      />
    </>
  );
};

export default AuthWrapper;